import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import SubmitAnswerModal from "./SubmitAnswerModal";
import api from "../../seller-apis/api";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import PaginationNew from "./Pagination";
var filterData = {
  pageNo: "1",
  size: 12,
  sortFilter: {
    _id: 1,
  },
  filter: {},
  productFilter: {},
};
function QuestionAnsList(props) {
  const [selectedData, setSelectedData] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedAns, setSelectedAns] = useState(null);
  const [show, setShow] = useState(false);
  const [editAnswer, setEditAnswer] = useState(false);
  const [answerIndex, setAnswerIndex] = useState(null);
  const [vendorId, setVendorId] = useState(localStorage.getItem("vendorId"));
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);

  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    getQA();
  }, [props.pId]);
  const getQA = (param = filterData) => {
    param.filter = {
      "productId-objectId": props.pId,
      active: true,
      "showQuestion.seller":true,
    };
    api.QandA.fetchQA(param).then((res) => {
      setSelectedData([...res.data]);
      setTotalRecords(res.totalRecords);
    });
  };

  function paginate(data) {
    filterData.pageNo = data.number;
    getQA(filterData);
    setSelectedPage(data.number);
  }
  return (
    <>
      <div className="mb-5 pb-4">
        {selectedData &&
          selectedData.map((question, index) => {
            return (
              <div key={index}>
                {question.answers && question.answers.length > 0 ? (
                  <div className="qalist" key={"ques" + index}>
                    <div className="question mb-2">
                      <div className="text">Q. {question.question}</div>
                      {question.answers.some((value) => {
                        return value.sellerId == vendorId;
                      }) ? (
                        <div className="button">
                          <button
                            className="edit-button icon-but"
                            style={{ borderRadius: 4 }}
                            onClick={() => {
                              setShow(true);
                              setSelectedQuestion(question);
                              setEditAnswer(true);
                              let ansIndex;
                              question.answers.forEach((ans, index) => {
                                if (ans.sellerId == vendorId) {
                                  ansIndex = index;
                                }
                              });
                              setAnswerIndex(ansIndex);
                            }}
                          >
                            <img
                              src="/edit-underline.webp"
                              style={{ width: 15 }}
                            />{" "}
                            Edit Answer
                          </button>
                        </div>
                      ):
                      (
                        <div className="button">
                        <button
                          className="edit-button icon-but"
                          style={{ borderRadius: 4 }}
                          onClick={() => {
                            setShow(true);
                            setSelectedQuestion(question);
                            setEditAnswer(false);
                          }}
                        >
                          <img
                            src="/edit-underline.webp"
                            style={{ width: 15 }}
                          />{" "}
                          Answer This Question
                        </button>
                      </div>
                      )
                      }
                    </div>
                    {question.answers.map((answer, index1) => {
                      return (
                        <div
                          className="answer"
                          key={"anslist" + index + index1}
                        >
                          {!answer.verified && answer.sellerId == vendorId && 
                            <>
                            <strong>
                                {answer.sellerId == vendorId
                                  ? "Your Answer :"
                                  : "A. :"}
                              </strong>
                              <span>{answer.answer} </span>
                              {answer.sellerId == vendorId ? (
                                <div className="answer-status">
                                  <img
                                    src="/exclamation.webp"
                                    alt="icon"
                                    style={{ width: 12 }}
                                  />
                                  <div>Pending for approval</div>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                         
                    }
                          {answer.verified&&
                              <><strong>
                                {answer.sellerId == vendorId
                                  ? "Your Answer :"
                                  : "A. :"}
                              </strong><span>{answer.answer} </span><span className="light">
                                  {answer.sellerId
                                    ? answer.sellerId == vendorId
                                      ? "Approved"
                                      : "By Seller"
                                    : answer.userName}{" "}
                                  <img src="/shield.png" style={{ width: 12 }} />
                                  {formatedDate(answer.updatedAt)}
                                </span></>
                           
                          }
                        </div>
                      );
                    })}
                    {/* <div className="answer">
                    <strong>A.</strong> Yes , the castor seed will also sown by
                    this assemble when I have viddeo then i will send let her{" "}
                    <div className="answer-status">
                      <img
                        src="/exclamation.webp"
                        alt="icon"
                        style={{ width: 12 }}
                      />
                      <div>Pending for approval</div>
                    </div>
                  </div> */}
                  </div>
                ) : (
                  <div className="qalist">
                    <div className="question">
                      <div className="text">Q. {question.question}</div>
                      <div className="button">
                        <button
                          className="edit-button icon-but"
                          style={{ borderRadius: 4 }}
                          onClick={() => {
                            setShow(true);
                            setSelectedQuestion(question);
                            setEditAnswer(false);
                          }}
                        >
                          <img
                            src="/edit-underline.webp"
                            style={{ width: 15 }}
                          />{" "}
                          Answer This Question
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="bottom-border"></div>
              </div>
            );
          })}
          <div className="hide-pagi-title">
        <PaginationNew
          number={totalrecords}
          paginate={paginate}
          activ={selectedPage}
          perPage={12}
          comp={"quesAnsList"}
        />
        </div>
      </div>
      <SubmitAnswerModal
        data={selectedQuestion}
        show={show}
        edit={editAnswer}
        handleClose={handleClose}
        refreshData={getQA}
        answerIndex={answerIndex}
      />
    </>
  );
}

export default QuestionAnsList;
